import styled from "styled-components"

import { MEDIA_QUERIES } from "@constants"

export const PostHeroWebinarWrapperDIV = styled.div`
  overflow: hidden;
  position: relative;
  padding-bottom: var(--spacing--L);

  ${MEDIA_QUERIES.L} {
    overflow: visible;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: calc(var(--container-width) - var(--container-padding-x) * 4);
    height: 1px;
    background-color: var(--color--charcoal-200);
  }

  .grid {
    align-items: center;
  }

  .column {
    &.desktop {
      display: none;
    }

    ${MEDIA_QUERIES.L} {
      &.desktop {
        position: relative;
        display: block;
      }

      &.mobile {
        display: none;
      }
    }

    &.webinar-form {
      display: flex;
      min-height: 400px;
      align-items: center;

      > div {
        flex: 0 0 100%;
      }
    }
  }
`

export const PostHeroWebinarContentDIV = styled.div`
  text-align: center;
  margin-bottom: var(--spacing--M);

  ${MEDIA_QUERIES.L} {
    text-align: left;
    margin-bottom: 0;
  }

  .pill {
    background: var(--color--charcoal-200);
    border-radius: var(--border-radius--S);
    display: inline-block;
    font-size: var(--font-size--S);
    line-height: var(--line-height--relaxed);
    margin-bottom: var(--spacing--XS);
    padding: 0 5px;
  }

  h1 {
    margin-bottom: 24px;
  }

  p {
    font-size: var(--font-size--L);
  }
`

export const PostHeroWebinarFormDIV = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  ${MEDIA_QUERIES.L} {
    /* hide form scrollbar */
    section {
      overflow-y: hidden !important;
    }
  }

  /* Wistia Turnstile Form */
  .wistiaHubspotFormWrapper {
    font-size: var(--font-size--XS);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .cookie-reset-container {
      display: none;
    }

    form {
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;

      .hs-form-field {
        margin: calc(var(--spacing-xs) / 2) 0;
        box-sizing: border-box;
        
        &.hs-email {
          width: 90%;
          ${MEDIA_QUERIES.L} {
            max-width: 480px;
          }
        }

        input {
          padding-right: 0;
        }
        input::placeholder {
          color: var(--color--charcoal-600);
        }
      }  
      /* error message container */
      .hs_error_rollup {
        width: 90%;
        max-width: 490px;
      }
      .hs-error-msg {
        font-family: var(--font-family--sans) !important;
      }
      .hs-error-msgs {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 90%;
        max-width: 490px;
        margin-left: auto;
        margin-right: auto;
        color: #cd2026;
        padding: 0;
        font-family: var(--font-family--sans) !important;
        li {
          display: flex;
          justify-content: center;
          font-family: var(--font-family--sans) !important;
        }
      }      
      /* parent container of consent checkbox field + privacy policy statement field */
      .legal-consent-container {
        padding: 0;
        margin: 0;
        width: 80%;
        max-width: 395px; 
        display: flex;
        flex-direction: column;
        align-items: center;
        

        .field.hs-form-field {
          margin: 0 !important; /* override form field margin just for the legal consent fields */
        }
        
        /* consent checkbox field */
        label.hs-form-booleancheckbox-display {
          display: flex;
          align-items: flex-start;
          margin-bottom: calc(var(--spacing--XS) / 2);

          p {
            line-height: var(--input-spacing);
          }

          p,
          span {
            color: var(--color--basics-white);
            font-size: var(--font-size--XS);
            font-family: var(--font-family--sans) !important;
          }
          span {
            margin-left: var(--input-spacing);
          }
        }

        /* privacy policy field */
        .hs-richtext {
          display: flex;
          justify-content: center;
          text-align: center;

          p {
            margin: 0;
          }

          p, a {
            color: #fff;
            font-size: var(--font-size--XS);
            font-family: var(--font-family--sans) !important;
          }
          a {
            color: #fff;
            text-decoration: underline;
          }
        }
      }/* end legal consent container */

      /* hide required field asterisk */

      .hs-form-required {
        display: none;
      }

      /* Register button */
      .email-field {
        width: 90%;
        box-sizing: border-box;
        ${MEDIA_QUERIES.M} {
          max-width: 480px;
        }
        margin-left: auto;
        margin-right: auto;

        input[type="submit"] {
          margin-top: calc(var(--spacing-xs)/ 2) !important;
          width: 100%;
          height: 42px;
          font-size: 15px !important;
          box-sizing: border-box !important;
          border-radius: 4px !important;
          /* Default button styles */
          -webkit-appearance: none;
          border: 0;
          display: inline-block;
          font-weight: 500;
          outline: 0;
          position: relative;
          text-align: center;
          text-decoration: none;
          transition: all 0.2s cubic-bezier(.455,.03,.515,.955);
          vertical-align: middle;
          background-color: var(--color--indigo-500) !important;
          color: white;
          font-family: var(--font-family--sans) !important;
          &:hover {
            background-color: var(--color--indigo-600) !important;
            color: white;
          }
        }
      }/* end email-field */

    }
  } /* End Wistia Turnstile Form */

  &.has-video {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  > .gatsby-image-wrapper {
    position: absolute !important;
    top: 50%;
    left: 50%;
    z-index: -1;
    width: min(100vw, 612px);
    transform: translate(-50%, -50%);
  }

  .Wistia {
    margin: 0;
  }
  
  /* hubspot form GDPR and privacy policy resets */
  ul {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
    }
  }
`

export const PostHeroWebinarFormFrameDIV = styled.div`
  background: white;
  border-radius: var(--border-radius--M);
  box-shadow: var(--elevation--XL);
  padding: var(--spacing--base-2) var(--spacing--base-2) calc(var(--spacing--base-2) + 52px);
  text-align: center;
  width: 100%;
  max-width: 458px;
  margin: 0 auto;
  position: relative;

  &.is-registered {
    padding: var(--spacing--base-2);
    text-align: center;

    .checkmark-image {
      width: 28px;
      height: 28px;
      margin: 0 auto var(--spacing--base-1);
    }
  }

  p {
    font-size: var(--font-size--S);
    color: var(--color--text-light);
    max-width: 290px;
    margin: 0 auto;
  }
`
